module.exports = __webpack_public_path__ + "static/img/btn_close.573c40a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/1212/btn_close.png
// module id = C416
// module chunks = 156